import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformBenefits = () => {
  const benefits = [
    {
      icon: 'Code',
      title: 'Hands-on Selenium Practice',
      description: 'Write and execute real Selenium code in our interactive environment with instant feedback and validation.'
    },
    {
      icon: 'Map',
      title: 'Mission-based Learning',
      description: 'Progress through structured missions designed to build your automation skills from beginner to advanced levels.'
    },
    {
      icon: 'Play',
      title: 'Real-time Code Execution',
      description: 'See your code run live with screenshots, logs, and detailed execution results in isolated containers.'
    },
    {
      icon: 'Trophy',
      title: 'Track Your Progress',
      description: 'Monitor your learning journey with detailed analytics, achievements, and skill progression tracking.'
    },
    {
      icon: 'Users',
      title: 'Community Learning',
      description: 'Join thousands of developers learning Selenium automation with shared code examples and best practices.'
    },
    {
      icon: 'Shield',
      title: 'Safe Learning Environment',
      description: 'Practice in secure, isolated containers without worrying about breaking anything or affecting production systems.'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-xl font-semibold text-foreground mb-2">
          Why Choose Selenium Sandbox?
        </h3>
        <p className="text-sm text-muted-foreground">
          Join thousands of developers mastering web automation
        </p>
      </div>
      <div className="grid gap-4">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-4 bg-card/50 rounded-lg border border-subtle hover:bg-card/70 transition-colors"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={benefit?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground mb-1">
                {benefit?.title}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg p-4 border border-primary/20">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Sparkles" size={16} color="var(--color-primary)" />
          <span className="text-sm font-medium text-foreground">
            Get Started Today
          </span>
        </div>
        <p className="text-xs text-muted-foreground">
          Create your account now and start your journey to becoming a Selenium automation expert. 
          No credit card required - begin learning immediately!
        </p>
      </div>
      <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
        <div className="flex items-center space-x-1">
          <Icon name="Users" size={12} />
          <span>15,000+ Learners</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="BookOpen" size={12} />
          <span>50+ Missions</span>
        </div>
        <div className="flex items-center space-x-1">
          <Icon name="Star" size={12} />
          <span>4.8/5 Rating</span>
        </div>
      </div>
    </div>
  );
};

export default PlatformBenefits;